<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="5" :sm="24">
            <a-form-item label="采销全流程">
              <a-select
                show-search
                allow-clear
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="projectFetching ? undefined : null"
                v-model="queryParam.project_id"
                placeholder="请输入名称"
                @search="this.projectSearch"
              >
                <a-spin v-if="projectFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in projectList" :key="d.id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="2" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
            </span>
          </a-col>
          <a-col :md="2" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleAdd">新建</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :data="loadData"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="items" slot-scope="items">
        <a @click="showItems(items)">
          <a-tag v-for="item in items" :key="item.id">
            {{ item.risk_warning_title }}
          </a-tag>
        </a>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleWatchView(record)">查看</a>
          <a-divider type="vertical" v-if="isEdited(record.create_by_id)"/>
          <a @click="handleEdit(record)" v-if="isEdited(record.create_by_id)">编辑</a>
          <a-divider type="vertical" v-if="isEdited(record.create_by_id)"/>
          <a-popconfirm
            v-if="isEdited(record.create_by_id)"
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelet(record)"
          >
            <a>删除</a>
          </a-popconfirm>
        </template>
        <a-divider type="vertical" />
        <a @click="handleSend(record)">发送</a>
      </span>
    </s-table>
    <create-form
      ref="createModal"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
    <a-drawer
      title="风险提示"
      width="800"
      placement="right"
      :closable="true"
      :visible="drawerVisible"
      @close="drawerVisible=false"
    >
      <div v-for="item in this.items" :key="item.id">
        <a-divider orientation="left">
          {{ item.risk_warning_title }}
        </a-divider>
        <p>{{ item.risk_warning_content }}</p>
        <div v-if="item.attachments">
          附件：
          <p v-for="attachment in item.attachments" :key="attachment.id">
            <a :href="attachment.url" target="_blank">
              {{ attachment.url }}
            </a>
          </p>
        </div>
      </div>
    </a-drawer>
    <send-form
      ref="sendModal"
      v-if="sendVisible"
      :visible="sendVisible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleSendCancel"
      @ok="handleSendOk"
    />
  </div>
</template>

<script>
import { STable } from '@/components'
import {
  in_process_risk_control_list,
  in_process_risk_control_create,
  in_process_risk_control_delete,
  in_process_risk_control_send
} from '@/api/trade_risk_control'
import { Dictionaries } from '@/common/AllConstant'
import CreateForm from '../modules/CreateForm'
import SendForm from '../modules/SendForm'
import debounce from 'lodash/debounce'
import { project_list } from '@/api/trade_project'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm,
    SendForm
  },
  data () {
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    return {
      loading: false,
      confirmLoading: false,
      dictionaries: Dictionaries,
      // 创建窗口控制
      visible: false,
      drawerVisible: false,
      sendVisible: false,
      items: undefined,
      mdl: {},
      projectFetching: false,
      projectList: [],
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '系统编号',
          dataIndex: 'number',
          width: 200,
          ellipsis: true
        },
        {
          title: '采销全流程',
          dataIndex: 'project',
          width: 200,
          ellipsis: true
        },
        {
          title: '风险提示',
          dataIndex: 'items',
          width: 200,
          ellipsis: true,
          scopedSlots: { customRender: 'items' }
        },
        {
          title: '创建人',
          dataIndex: 'create_by',
          width: 150,
          ellipsis: true
        },
        {
          title: '时间',
          width: 180,
          dataIndex: 'create_time',
          ellipsis: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData.parameter', parameter)
        return in_process_risk_control_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            console.log(res.data, '我是数据列表@')
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: false
    }
  },
  created () {
    this.tableOption()
    console.log(this.$Dictionaries)
  },
  computed: {
    isEdited () {
      return (create_by_id) => {
        const info = this.$store.state.user.info
        return create_by_id === info.id || create_by_id === -1
      }
    }
  },
  methods: {
    handleProjectSearch (value) {
      this.projectFetching = true
      this.projectList = []
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = result
      }).finally(() => {
        this.projectFetching = false
      })
    },
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleAdd () {
      const date = new Date()
      const year = date.getFullYear()
      const month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
      const day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
      const hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
      const minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
      this.mdl = { number: year + '' + month + '' + day + '' + hours + minutes }
      this.visible = true
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleWatchView (record) {
      this.showItems(record.items)
    },
    handleEdit (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/in_process_risk_control/' + record.id })
    },
    handleDelet (record) {
      in_process_risk_control_delete(record.id).then((res) => {
        console.log(res)
        console.log('删除成功------')

        this.$refs.table.refresh()
      })
    },
    handleSend (record) {
      this.sendVisible = true
      this.mdl = record
    },
    handleSendCancel () {
      this.sendVisible = false
      const form = this.$refs.sendModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleOk (data) {
      const form = this.$refs.createModal.form
      form.validateFields((errors, values) => {
        if (!errors) {
          values = { ...values, ...data }
          console.log('values', values)
            // 新增
          this.confirmLoading = true
          in_process_risk_control_create(values).then(res => {
            if (res.code === 1000) {
              this.visible = false
              this.confirmLoading = false
              // 重置表单数据
              form.resetFields()
              // 刷新表格
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    showItems (items) {
      this.drawerVisible = true
      this.items = items
    },
    riskWarning (item) {
      this.$message.warning('确定要删除' + item.risk_warning_title + '?')
    },
    handleSendOk (data) {
      const form = this.$refs.sendModal.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('====', values)
          console.log('发送给：', this.mdl, data)
          this.confirmLoading = true
          const userIds = data.map(item => item.user_id)
          in_process_risk_control_send({ users: userIds, items: values['item_ids'] }, this.mdl['id']).then(res => {
            if (res.code === 1000) {
              this.sendVisible = false
              form.reset()
            }
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    }
  }
}
</script>
